import React from "react";
import "./button.css";
import { getSelectedYr, getBacklogStatus } from "./calculations";

function Button() {
  const handleClick = () => {
   
  };

  return (
    <div>
      <button onClick={handleClick} className="button">
        Submit
      </button>
    </div>
  );
}

export default Button;
